import React from 'react';

const IS_LTC_RELEASE = true;

export const IsLtc = () => {
    return (
        <div
            data-testid="ltc-flag"
            data-is-ltc={IS_LTC_RELEASE}
            aria-hidden="true"
        />
    );
};
